import { DigitalRevisionMenuItem } from '../../interfaces/digital-revision-menu-item';
import { ProxyTypeEnum } from '../../interfaces/proxy-type-enum';
import { MenuItemTypeEnum } from '../../interfaces/menu-item-type-enum';
import { CombinedMenuItemTypeEnum } from '../../interfaces/combined-menu-item-type-enum';
import { MenuItemModel } from '../../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Quick Quiz',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'combined-quick-quiz',
  },
  {
    Text: 'Summary Test',
    ImagePath: '/assets/images/landing/revision-summary-test.png',
    DestinationPage: 'combined-revision-summary-quiz',
  },
  {
    Text: 'Video Explanations',
    ImagePath: '/assets/images/landing/video-explanations.png',
    DestinationPage: 'combined-content-videos',
  },
  {
    Text: 'Video Solutions',
    ImagePath: '/assets/images/landing/video-solutions.png',
    DestinationPage: 'combined-video-solutions',
  },
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.CombinedQuickQuiz,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Free sample quiz',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl:
          '_revisionhub_opc/SciHub_FreeSamples/SAMPLE_GCSEAQA_Chemistry_QuickQuiz_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl:
          '_revisionhub_opc/SciHub_FreeSamples/SAMPLE_GCSEAQA_Physics_QuickQuiz_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl:
          '_revisionhub_opc/SciHub_FreeSamples/SAMPLE_GCSEAQA_Biology_QuickQuiz_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Test yourself with quizzes covering every topic. On your marks, get set... quiz!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedMistakesQuiz,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Get access with your book',
    ButtonURL: 'combined-revision-summary-quiz',

    MixedOnlineTests: [],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: true,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here &mdash; have another go and conquer them once and for all!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers\n',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedRevisionSummaryQuiz,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Free sample test',
    ButtonURL: '',

    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl:
          '_revisionhub_opc/SciHub_FreeSamples/SAMPLE_GCSEAQA_Chemistry_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl: '_revisionhub_opc/SciHub_FreeSamples/SAMPLE_GCSEAQA_Physics_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl: '_revisionhub_opc/SciHub_FreeSamples/SAMPLE_GCSEAQA_Biology_RevSum_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Get access with your book',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],
    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: true,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedVideoExplanations,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Free sample videos',
    MixedOnlineTests: [],
    ButtonURL: '',
    HasData: false,
    HeadingText: 'Video Explanations',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Our Science experts break down key concepts for you — even the tricky bits!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Get to grips with key concepts',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        Title: 'Video Explanations',
        Intro:
          '<p>These handy videos explain some of the key concepts in your book. You can unlock all the videos when you buy your <a href="[[external_domain]]/product_scahs43"  class="link-button" style="color: #1494D4">Combined Science revision book</a>!<br />\n' +
          '&nbsp;</p>\n',
        LeftSections: [
          {
            Header: 'Topic 1b — Exchanging Substances',
            Subcategories: [
              {
                Name: 'Diffusion',
                ShortName: 'Diffusion',
                Link: 'https://www.youtube.com/embed/TahOKtPHrl4?rel=0&modestbranding=1',
              },
              {
                Name: 'Osmosis',
                ShortName: 'Osmosis',
                Link: 'https://www.youtube.com/embed/CizgcfyOFoY?rel=0&modestbranding=1',
              },
              {
                Name: 'Active Transport in the Gut',
                ShortName: 'Active-Transport-in-the-Gut',
                Link: 'https://www.youtube.com/embed/qluo1t2JKAc?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        Title: 'Video Explanations',
        Intro:
          '<p>These handy videos explain some of the key concepts in your book. You can unlock all the videos when you buy your <a href="[[external_domain]]/product_scahs43"  class="link-button" style="color: #1494D4">Combined Science revision book</a>!<br />\n' +
          '&nbsp;</p>\n',
        LeftSections: [
          {
            Header: 'Topic 1a — Atoms, Elements, Compounds and Mixtures',
            Subcategories: [
              {
                Name: 'Structure of the Atom',
                ShortName: 'Structure-of-the-Atom',
                Link: 'https://www.youtube.com/embed/qlICQ6YZbWU?rel=0&modestbranding=1',
              },
              {
                Name: 'Paper Chromatography',
                ShortName: 'Paper-Chromatography',
                Link: 'https://www.youtube.com/embed/wrGI1vHoLtU?rel=0&modestbranding=1',
              },
              {
                Name: 'Separation Techniques',
                ShortName: 'Separation-Techniques',
                Link: 'https://www.youtube.com/embed/IeoWXK3we-E?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        Title: 'Video Explanations',
        Intro:
          '<p>These handy videos explain some of the key concepts in your book. You can unlock all the videos when you buy your <a href="[[external_domain]]/product_scahs43"  class="link-button" style="color: #1494D4">Combined Science revision book</a>!<br />\n' +
          '&nbsp;</p>\n',
        LeftSections: [
          {
            Header: 'Topic 5b — Forces and Motion',
            Subcategories: [
              {
                Name: 'Terminal Velocity',
                ShortName: 'Terminal-Velocity',
                Link: 'https://www.youtube.com/embed/LLOI0dG4zAg?rel=0&modestbranding=1',
              },
              {
                Name: "Newton\'s Third Law",
                ShortName: "Newton\'s Third Law",
                Link: 'https://www.youtube.com/embed/T_Bc3pHu8A4?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedVideoSolutions,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Free sample videos',
    MixedOnlineTests: [],
    ButtonURL: '',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        Title: 'Video Solutions',
        Intro:
          '<p>CGP&#39;s friendly experts are here to walk you through some of the exam-style questions in your book. Buy your <a href="[[external_domain]]/product_scahs43"  class="link-button" style="color: #1494D4">Combined Science revision book</a> now to access all the videos!<br />\n' +
          '&nbsp;</p>\n',
        LeftSections: [
          {
            Header: 'Topic 1a — Cells and Microscopy',
            Subcategories: [
              {
                Name: 'Magnification',
                ShortName: 'Magnification',
                Link: 'https://www.youtube.com/embed/MEREsZWMRZE?rel=0&modestbranding=1',
              },
              {
                Name: 'Mitosis',
                ShortName: 'Mitosis',
                Link: 'https://www.youtube.com/embed/B9GedI8mWbQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Binary Fission',
                ShortName: 'Binary-Fission',
                Link: 'https://www.youtube.com/embed/jvPqYtINPqs?rel=0&modestbranding=1',
              },
              {
                Name: 'Inhibition Zones',
                ShortName: 'Inhibition-Zones',
                Link: 'https://www.youtube.com/embed/-w3UJt-iAmM?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        Title: 'Video Solutions',
        Intro:
          '<p>CGP&#39;s friendly experts are here to walk you through some of the exam-style questions in your book. Buy your <a href="[[external_domain]]/product_scahs43"  class="link-button" style="color: #1494D4">Combined Science revision book</a> now to access all the videos!<br />\n' +
          '&nbsp;</p>\n',
        LeftSections: [
          {
            Header: 'Topic 1a — Atoms, Elements, Compounds & Mixtures',
            Subcategories: [
              {
                Name: 'Atoms',
                ShortName: 'Atoms',
                Link: 'https://www.youtube.com/embed/m1vMiZvzGaE?rel=0&modestbranding=1',
              },
              {
                Name: 'Calculating Relative Atomic Mass',
                ShortName: 'Calculating-Relative-Atomic-Mass',
                Link: 'https://www.youtube.com/embed/WakAOxVH4sY?rel=0&modestbranding=1',
              },
              {
                Name: 'Compound Formulas',
                ShortName: 'Compound-Formulas',
                Link: 'https://www.youtube.com/embed/ILzKxoQXf4Q?rel=0&modestbranding=1',
              },
              {
                Name: 'Chemical Equations',
                ShortName: 'Chemical-Equations',
                Link: 'https://www.youtube.com/embed/9ihnB-r4_qo?rel=0&modestbranding=1',
              },
              {
                Name: 'Distillation',
                ShortName: 'Distillation',
                Link: 'https://www.youtube.com/embed/340kfE8xEfs?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        Title: 'Video Solutions',
        Intro:
          '<p>CGP&#39;s friendly experts are here to walk you through some of the exam-style questions in your book. Buy your <a href="[[external_domain]]/product_scahs43"  class="link-button" style="color: #1494D4">Combined Science revision book</a> now to access all the videos!<br />\n' +
          '&nbsp;</p>\n',
        LeftSections: [
          {
            Header: 'Topic 1a — Energy Stores & Transfers',
            Subcategories: [
              {
                Name: 'Energy Stores and Transfers',
                ShortName: 'Energy-Stores-and-Transfers',
                Link: 'https://www.youtube.com/embed/fGtie6c3dEA?rel=0&modestbranding=1',
              },
              {
                Name: 'Kinetic and Potential Energy Stores',
                ShortName: 'Kinetic-and-Potential-Energy-Stores',
                Link: 'https://www.youtube.com/embed/QzKGF5Recv4?rel=0&modestbranding=1',
              },
              {
                Name: 'Specific Heat Capacity',
                ShortName: 'Specific-Heat-Capacity',
                Link: 'https://www.youtube.com/embed/-7Ld5j5l84k?rel=0&modestbranding=1',
              },
              {
                Name: 'Power Output',
                ShortName: 'Power-Output',
                Link: 'https://www.youtube.com/embed/jHR0vsRlNmM?rel=0&modestbranding=1',
              },
              {
                Name: 'Efficiency',
                ShortName: 'Efficiency',
                Link: 'https://www.youtube.com/embed/BORdE6I2aTM?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Get access with your book',
    MixedOnlineTests: [],
    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: true,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, resource sheets, exam tips and a glossary... yep, it's all right here.</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.HowToRevise,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '#0993A3',
    ButtonCustomClasses: '',
    ButtonText: 'Get access with your book',
    ButtonURL: 'how-to-revise',
    MixedOnlineTests: [],
    HasData: false,
    HeadingText: 'How to Revise',
    IsButtonDisabled: true,
    IsSwitcher: false,
    MainContentText:
      "We\'ve spilled all the secrets to help you get the most out of your book and CGP RevisionHub",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Revision tips and tricks',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        LeftSections: [],
        RightSections: [],
        Title: '',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      IntroTitle: '',
      AdditionalInfo: '',
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: 'frequently-asked-questions',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        'We’ve put together lots of helpful information on how to get the most out of your Complete Revision and Practice. And if you’ve hit any snags, you’ll find the answers you need here too.  ',
      Text:
        ' <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science books. Use the quizzes, tests, videos and more to revise what you’ve learned from your book and practise for the exams.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I access CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig so you can practise exactly what you've just learned!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>My RevisionHub isn’t working — what do I do?&nbsp;</h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also lots of useful bits that you can download as PDFs to access offline. Phew.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What’s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the key facts, maths skills and practical skills on the course. There's one on almost every page of your book — we're generous like that.</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier.</p>\n" +
        '\n' +
        "<p>Revision Summary Tests include more challenging questions — if you can do them all, you'll know you've covered everything. You'll find one at the end of every section in your book and you can mark them yourself using our example answers.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in the Hub and start again?&nbsp;</h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Plus, you can edit your Revision Summary Test answers as your skills and understanding develop. Keep going, we believe in you!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I share my quiz scores and test results with other people?&nbsp;</h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I’ve answered all the questions?&nbsp;</h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. Check out the How To Revise page in your RevisionHub if you want more top revision tips before your exams.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise.<br>\n" +
        '&nbsp;</p>',
      VideoLink: 'https://www.youtube.com/embed/9IJ-TRt6jTk?rel=0&modestbranding=1',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: true,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from. Take a look at some of our other books!",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
];
